import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { AppStoreBadge } from '../StoreButtons';

const GuideCTA = ({ title, description }) => (
  <section className="py-24 bg-[#1E2328]" data-testid="guide-cta">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">{title}</h2>
      <p className="text-xl text-slate-400 mb-12 max-w-3xl mx-auto">{description}</p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
        <AppStoreBadge className="h-14" />
      </div>
      <p className="text-slate-500">Now available on the Apple App Store</p>
      <div className="mt-12 pt-8 border-t border-white/10">
        <Link to="/fly-guide" className="inline-flex items-center text-[#3aa0e0] hover:text-[#3aa0e0] font-semibold transition-colors">
          <ArrowLeft className="w-5 h-5 mr-2" />
          Back to Complete Fly Selection Guide
        </Link>
      </div>
    </div>
  </section>
);

export default GuideCTA;
